// @flow
import { browserHistory } from 'react-router';
import { makeAPICall } from '../generalCreators';
import type { ThunkAction, User, Action } from '../../types';

export const REQUESTING_LOGIN = 'REQUESTING_LOGIN';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_TOKEN_CONTENT = 'SET_TOKEN_CONTENT';
export const LOGOUT = 'LOGOUT';

export function login(username: string, password: string): ThunkAction {
  return function(dispatch) {
    // set loading to true
    dispatch(requestingLogin());

    const endpoint = '/account/login';
    const options = {
      method: 'POST',
      data: { username, password }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const token = response.data.token;
        const user = response.data.user;
        dispatch(setToken(token, user));
        dispatch(decodeToken(token)).then(() => {
          // Redirect to user's default starting page
          const defaultPage = user.defaultPage || '/';
          browserHistory.push(defaultPage);
        });
      },
      error =>
        dispatch(loginError(error.data ? error.data.message : error.message))
    );
  };
}

export type RequestingLoginAction = {
  type: 'REQUESTING_LOGIN'
};

export function requestingLogin(): RequestingLoginAction {
  return { type: REQUESTING_LOGIN };
}

export function setToken(token: string, user: User): Action {
  return { type: SET_TOKEN, token, user };
}

export function decodeToken(token: string): ThunkAction {
  return function(dispatch) {
    const endpoint = '/account/decodetoken';
    const options = {
      method: 'GET',
      headers: { token }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch({
          type: 'SET_TOKEN_CONTENT',
          tokenContent: response.data.content
        });
      },
      error => dispatch(loginError(error.data.message))
    );
  };
}

export function loginError(errorMsg: string): ThunkAction {
  return function(dispatch) {
    const defaultMsg = 'Something went wrong. Please try again.';
    dispatch({ type: 'LOGIN_ERROR', error: errorMsg || defaultMsg });
    browserHistory.replace('/login');
  };
}

export function logout(): ThunkAction {
  return function(dispatch) {
    dispatch({ type: LOGOUT });
    browserHistory.replace('/login');
  };
}



// WEBPACK FOOTER //
// ./src/actions/authentication/loginCreators.js